import { history } from "../../src/index";
import * as types from '../constants/auditdetails';
import * as auditdetailsApi from '../api/auditdetails';

export function getauditList(audittype, objModel) {
    // console.log("fetchTeamDetailsList action call");
    return dispatch => {
        dispatch({ type: types.FETCH_AUDIT_LIST_REQUEST });
        // var objModel = {
        //     "updatedFrom":"2018/02/01",
        //     "updatedTo":"2018/04/01",
        //     "modified_by":null
        // }       
        // console.log(objModel);
        auditdetailsApi.getauditList(audittype, objModel)
            .then(function (response) {
                //  console.log("fetchauditDetailsList", response)
                dispatch({ type: types.FETCH_AUDIT_LIST_REQUEST_COMPLETED, data: response.data });
            })
            .catch(function (err) {
                // console.log("fetchTeamDetailsList Error", err)
                dispatch({ type: types.FETCH_AUDIT_LIST_REQUEST_ERROR });
            });
    }
}





// WEBPACK FOOTER //
// ./actions/auditdetails.js